function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeGrid as Grid } from 'react-window';
import Box from '../Box';
import Flex from '../Flex';
import HeaderCell from './HeaderCell';
import { SpreadsheetContext } from './SpreadsheetManager';
const SpreadsheetGrid = /*#__PURE__*/React.memo(props => {
  const headerRef = React.useRef(null);
  const handleScroll = React.useCallback(_ref => {
    let {
      scrollLeft
    } = _ref;
    return headerRef.current && headerRef.current.scrollTo({
      scrollLeft
    });
  }, []);
  const cellRendererWrapper = /*#__PURE__*/React.memo(cellProps => {
    const {
      rows,
      headerCells
    } = React.useContext(SpreadsheetContext);
    const row = rows[cellProps.rowIndex];
    const column = headerCells[cellProps.columnIndex];
    const value = row[column.prop];
    return props.cellRenderer({
      ...cellProps,
      row,
      column,
      value
    });
  });
  const headerCellRenderer = /*#__PURE__*/React.memo(_ref2 => {
    let {
      style,
      columnIndex
    } = _ref2;
    return /*#__PURE__*/React.createElement(HeaderCell, _extends({
      style: style
    }, props.headerCells[columnIndex]));
  });
  return /*#__PURE__*/React.createElement(Flex, {
    flex: 1,
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: "0 0 40px"
  }, /*#__PURE__*/React.createElement(AutoSizer, null, _ref3 => {
    let {
      width
    } = _ref3;
    return /*#__PURE__*/React.createElement(Grid, {
      ref: headerRef,
      columnCount: props.headerCells.length,
      columnWidth: i => props.headerCells[i].width,
      height: 40,
      rowCount: 1,
      rowHeight: () => 40,
      width: width,
      style: {
        backgroundColor: 'white',
        overflow: 'hidden'
      },
      overscanColumnCount: 2,
      overscanRowCount: 0,
      children: headerCellRenderer
    });
  })), /*#__PURE__*/React.createElement(Box, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(AutoSizer, null, _ref4 => {
    let {
      height,
      width
    } = _ref4;
    return /*#__PURE__*/React.createElement(Grid, {
      columnCount: props.headerCells.length,
      columnWidth: i => props.headerCells[i].width,
      height: height,
      rowCount: props.rows.length,
      rowHeight: () => 40,
      width: width,
      style: {
        backgroundColor: 'white'
      },
      onScroll: handleScroll,
      overscanColumnCount: 2,
      overscanRowCount: 2,
      children: cellRendererWrapper
    });
  })));
});
SpreadsheetGrid.propTypes = {
  cellRenderer: PropTypes.func.isRequired,
  headerCells: PropTypes.arrayOf(PropTypes.object).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired
};
SpreadsheetGrid.defaultProps = {};
SpreadsheetGrid.displayName = 'SpreadsheetGrid';
export default SpreadsheetGrid;